@let properties = feature()?.properties;
@if (
  ready && feature() && isObject(properties) && properties?.target !== 'iframe'
) {
  <table class="igo-striped">
    <tbody>
      @for (
        property of filterFeatureProperties(feature()) | keyvalue;
        track property
      ) {
        <tr>
          @if (properties?.target === '_blank' && property.key === 'url') {
            <td>
              <mat-icon matListItemIcon>{{ icon }}</mat-icon>
            </td>
          }
          @if (properties?.target === '_blank' && property.key === 'url') {
            <td>
              <a
                href="{{ property.value }}"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ 'igo.geo.targetHtmlUrl' | translate }} {{ title }}</a
              >
              <button
                matIconButton
                (click)="copyTextToClipboard(property.value)"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
            </td>
          }
          @if (properties?.target === undefined) {
            <td id="keyValue">
              {{ property.key }}
            </td>
          }
          @if (
            properties?.target === undefined &&
            !isObject(property.value) &&
            !isUrl(property.value) &&
            !hasEmbeddedLinks(property.value)
          ) {
            <td [innerHTML]="property.value"></td>
          }
          @if (
            properties?.target === undefined && hasEmbeddedLinks(property.value)
          ) {
            <td>
              <u
                [ngStyle]="{ cursor: 'pointer', color: 'blue' }"
                (click)="openSecureUrl(property.value)"
                >{{ getEmbeddedLinkText(property.value) }}</u
              >
            </td>
          }
          @if (
            properties?.target === undefined &&
            !isObject(property.value) &&
            (isDoc(property.value) || isUrl(property.value)) &&
            !isImg(property.value)
          ) {
            <td>
              <u
                [ngStyle]="{ cursor: 'pointer', color: 'blue' }"
                (click)="openSecureUrl(property.value)"
                >{{ 'igo.geo.targetHtmlUrl' | translate }}</u
              >
              <button
                matIconButton
                (click)="copyTextToClipboard(property.value)"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
            </td>
          }
          @if (
            properties?.target === undefined &&
            !isObject(property.value) &&
            isUrl(property.value) &&
            isImg(property.value)
          ) {
            <td>
              <a
                href="{{ property.value }}"
                target="_blank"
                (click)="openSecureUrl(property.value)"
                rel="noopener noreferrer"
              >
                <img
                  igoImageError
                  src="{{ property.value | secureImage | async }}"
                  width="225"
                  height="auto"
                />
              </a>
            </td>
          }
          @if (properties?.target === undefined && isObject(property.value)) {
            <td [innerHTML]="property.value | json"></td>
          }
        </tr>
      }
    </tbody>
  </table>
}

@if (isHtmlDisplay()) {
  <iframe
    [srcdoc]="htmlSanitizer(properties)"
    [src]="urlSanitizer(properties?.url)"
  ></iframe>
}
